export function generateTeamName(index, numTeams, numPlayersTeam, playersCount) {   
    const teams = ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H'];
    // STEP: playersPerTeam, for example 5
    // FOR EACH STEP: INCREMENT TEAM NAME BY 1
    function teamNumber(index) {
        let teamNumber = (index/numPlayersTeam);
        if (teamNumber === 0) {
            teamNumber = 1
        } else if (teamNumber/teamNumber === 1) {
            teamNumber = teamNumber + 0.1
        }
        //console.log(index/playersPerTeam)
        return Math.ceil(teamNumber)
    }
    function generateTeamNamePlayer(teamNumber) {
        return teams[teamNumber]
    }



    let finalTeamNumber
        
    const teamNumberGenerated = teamNumber(index-1);
    //console.log(teamNumberGenerated)

    // IF TEAM NUMBER GENERATED === 9 AND INDEX IS 9
    if (teamNumberGenerated === 9) {


        if ((playersCount - index) === 0) {
            finalTeamNumber = 1
        } else if ((playersCount - index) === 1) {
            finalTeamNumber = 2
        } else if ((playersCount - index) === 2) {
            finalTeamNumber = 3
        } else if ((playersCount-index) === 3) {
            finalTeamNumber = 4
        } else if ((playersCount-index) === 4) {
            finalTeamNumber = 5
        } else if ((playersCount-index) === 5) {
            finalTeamNumber = 6
        } else if ((playersCount-index) === 6) {
            finalTeamNumber = 7
        } else if ((playersCount-index) === 7) {
            finalTeamNumber = 8
        }

    } else {
        finalTeamNumber = teamNumberGenerated
    }

    const teamNameGenerated = generateTeamNamePlayer(finalTeamNumber-1);
    //console.log(teamNameGenerated, "Team NAme Generated")
    return teamNameGenerated;

}